import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ServiceGroup } from '@/types/serviceGroup';
import { useExtractLinksFromService } from '@/components/pages/Service/Detail/shared/hooks/useExtractLinks';

import { LPLink } from '../../../shared/Presentation/LPLink';
import { ServiceGroupDescription } from '../../../shared/Presentation/ServiceGroupDescription';
import { SubHeader } from '../../../shared/Presentation/SubHeader';
import { SsoLink } from '../../../shared/Presentation/SsoLink';
import { AdminLinks } from './AdminLinks';

type Props = {
  service: ServiceGroup;
};

export const GLS: React.FC<Props> = ({ service }) => {
  const links = useExtractLinksFromService(service);
  const lpLinkUrl = links.landingPage?.url || '';
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <>
      <SubHeader service={service} />
      <ServiceGroupDescription>{service.description}</ServiceGroupDescription>
      {lpLinkUrl && <LPLink url={lpLinkUrl} />}
      {/* TODO: 研修PMSリリース後に表示条件確認を削除する  */}
      {/* https://github.com/globis-org/glopla-dev-portal/issues/1554 */}
      {links.otherSso && (
        <>
          <SsoLink link={links.otherSso} serviceGroupId={service.id} />
          <ItemWrapper>
            <ServiceGroupDescription>
              <Trans i18nKey="pages.project.subscription.index.pmsSsoMessage"></Trans>
            </ServiceGroupDescription>
          </ItemWrapper>
          <AdminLinks
            links={links.admin}
            serviceGroupId={service.id}
            locale={locale}
          />
          <ServiceGroupDescription>
            <Trans i18nKey="pages.project.subscription.index.glmsSsoMessage"></Trans>
          </ServiceGroupDescription>
        </>
      )}
    </>
  );
};

const ItemWrapper = styled.div`
  & > * {
    margin-bottom: 48px;
  }
  width: 100%;
`;
